export const Panels = {
  InventoryInstance: 'InventoryInstance',
  BackupJobsCard: 'BackupJobsCard',
  ScanJobsCard: 'ScanJobsCard',
  RestoreJobsCard: 'RestoreJobsCard',
  RestoreVolumeWizard: 'RestoreVolumeWizard',
  RestoreEc2InstanceWizard: 'RestoreEc2InstanceWizard',
  RestoreFileWizard: 'RestoreFileWizard',
  RestoreRDSWizard: 'RestoreRDSWizard',
  RestoreRDSPitrWizard: 'RestoreRDSPitrWizard',
  RestoreDynamoWizard: 'RestoreDynamoWizard',
  RestoreKeyspacesWizard: 'RestoreKeyspacesWizard',
  RestoreS3Wizard: 'RestoreS3Wizard',
  RestoreMongoAtlasWizard: 'RestoreMongoAtlasWizard',
  RestoreAzureVMWizard: 'RestoreAzureVMWizard',
  RestoreAzureVMPitrWizard: 'RestoreAzureVMPitrWizard',
  RestoreAzureDiskWizard: 'RestoreAzureDiskWizard',
  RestoreEksNamespaceWizard: 'RestoreEksNamespaceWizard',
  RestoreAzureSqlDBWizard: 'RestoreAzureSqlDBWizard',
  RestoreAzurePostgresWizard: 'RestoreAzurePostgresWizard',
  CreateBackupVault: 'CreateBackupVault',
  BackupPolicyConfig: 'BackupPolicyConfig',
  CustomRole: 'CustomRole',
  ApiCredentials: 'ApiCredentials',
  RotateApiCredentials: 'RotateApiCredentials',
  NotificationPolicy: 'NotificationPolicy',
  Integration: 'Integration',
  SAML: 'SAML',
  Filters: 'Filters',
  Control: 'Control',
  RecreateAccountRoleAWSPanel: 'RecreateAccountRoleAWSPanel',
  RecreateAccountRoleGCPPanel: 'RecreateAccountRoleGCPPanel',
  ConnectAwsVaultAccount: 'ConnectAwsVaultAccount',
  UpsertUser: 'UpsertUser',
  UpsertGroupMapping: 'UpsertGroupMapping',
  ConvertToAMIWizard: 'ConvertToAMIWizard',
  RestoreServerConnectivityPanel: 'RestoreServerConnectivityPanel',
  RestoreServerTagsPanel: 'RestoreServerTagsPanel',
  MetricsPanel: 'MetricsPanel',
  ConvertToMultipleEonSnapshots: 'ConvertToMultipleEonSnapshots',
  ConvertToSingleEonSnapshot: 'ConvertToSingleEonSnapshot',
  ObjectStoreBackupConfiguration: 'ObjectStoreBackupConfiguration',
  RestoreGcpVMWizard: 'RestoreGcpVMWizard',
  RestoreGcpDiskWizard: 'RestoreGcpDiskWizard',
  RestoreGcpCloudSqlWizard: 'RestoreGcpCloudSqlWizard',
  RestoreBigQueryWizard: 'RestoreBigQueryWizard',
  RestoreFSxWizard: 'RestoreFSxWizard',
  RestoreEFSWizard: 'RestoreEFSWizard',
  RestoreRedshiftWizard: 'RestoreRedshiftWizard',
  RestoreDocumentdbWizard: 'RestoreDocumentdbWizard',
  RestoreNeptuneWizard: 'RestoreNeptuneWizard',
  UpdateAccountAWSPanel: 'UpdateAccountAWSPanel',
  UpdateAccountGCPPanel: 'UpdateAccountGCPPanel',
  UpdateAccountAzurePanel: 'UpdateAccountAzurePanel',
  RansomwareConditionPanel: 'RansomwareByConditionPanel',
  BackupScopeResourcesPanel: 'BackupScopeResourcesPanel',
  AzureOwnCloudOnboardingWizard: 'AzureOwnCloudOnboardingWizard',
  AzureOnboardingWizard: 'AzureOnboardingWizard',
  AzureConnectRestoreWizard: 'AzureConnectRestoreWizard',
  AzureConnectSourceWizard: 'AzureConnectSourceWizard',
  AzureConnectTenantWizard: 'AzureConnectTenantWizard',
  GcpConnectAccountWizard: 'GcpConnectAccountWizard',
  MongoAtlasConnectSourceWizard: 'MongoAtlasConnectSourceWizard',
  MongoAtlasConnectRestoreWizard: 'MongoAtlasConnectRestoreWizard',
  MongoAtlasPrivateLinkWizard: 'MongoAtlasPrivateLinkWizard',
  RestoreMongoAtlasPrivateLinkWizard: 'RestoreMongoAtlasPrivateLinkWizard',
  AwsConnectAccountWizard: 'AwsConnectAccountWizard',
  StorageGatewayWizard: 'StorageGatewayWizard',
  ConfigureProjectLimitsWizard: 'ConfigureProjectLimitsWizard',
  LogSpaceRecordCard: 'LogSpaceRecordCard',
  SparkEngineInstance: 'SparkEngineInstance',
  SqlEngineInstance: 'SqlEngineInstance',
  JobTemplateInstance: 'JobTemplateInstance',
  SavedQueryInstance: 'SavedQueryInstance',
  IngestionPipelineInstance: 'IngestionPipelineInstance',
  NotebookInstance: 'NotebookInstance',
  QueryExecutionInstance: 'QueryExecutionInstance',
  SparkJobInstance: 'SparkJobInstance',
  CreateGraphWizard: 'CreateGraphWizard',
  SqlQueryAnalyzer: 'SqlQueryAnalyzer',
  CreateIngestionPipelineWizard: 'CreateIngestionPipelineWizard',
  UpdateIngestionPipelineWizard: 'UpdateIngestionPipelineWizard',
  ConnectorInstance: 'ConnectorInstance',
  AddConnectorWizard: 'AddConnectorWizard',
  AddCatalogWizard: 'AddCatalogWizard',
  CreateSqlEngineWizard: 'CreateSqlEngineWizard',
  CreateSparkEngineWizard: 'CreateSparkEngineWizard',
  CreateJobTemplateWizard: 'CreateJobTemplateWizard',
  UpdateJobTemplateWizard: 'UpdateJobTemplateWizard',
  SubmitSparkJobWizard: 'SubmitSparkJobWizard',
  SetupVpcPeeringWizard: 'SetupVpcPeeringWizard',
  AddPrivateLinkWizard: 'AddPrivateLinkWizard',
  ZeroEtlPolicyConfig: 'ZeroEtlPolicyConfig',
  BackupZeroEtlPolicyConfig: 'BackupZeroEtlPolicyConfig',
  RdsCdcWizard: 'RdsCdcWizard',
  RestoreGoogleWorkspaceWizard: 'RestoreGoogleWorkspaceWizard',
  ConnectSaasWorkspaceWizard: 'ConnectSaasWorkspaceWizard',
} as const;

export type Panels = (typeof Panels)[keyof typeof Panels];
